import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { payrollStaffTpl } from 'api/payroll';
import { baseHeaders } from 'util/axios-request';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    importList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    action: {
      type: String,
      default: '',
      required: true
    },
    uploadData: {
      type: Object,
      default: function _default() {}
    },
    onSuccess: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    resultParams: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false,
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      uploadUrl: baseURL + this.action,
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      upload_total_count: 0,
      // 总数
      upload_success_count: 0,
      // 成功数
      upload_fail_count: 0,
      // 失败数
      feedback_file_url: '',
      form: {
        name: ''
      }
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
    },
    handleExport: function handleExport(type) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return payrollStaffTpl({
                settlement_type: type
              });
            case 2:
              res = _context.sent;
              if (res && res.code === 1) window.open(res.data.template_url);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(this.$t('730', {
          fileSize: this.fileSize
        }));
        return false;
      }
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      this.onSuccess(res);
      var response = res;
      var data = response.data;
      if (response && response.code === 1) {
        // 部分成功
        this.upload_total_count = data[this.resultParams.allname];
        this.upload_success_count = data[this.resultParams.successName];
        this.upload_fail_count = data[this.resultParams.errorNum];
        this.feedback_file_url = data.object_url || data.feedback_file_url;
      } else {
        // 全部失败
        // this.upload_total_count = data.upload_total_count
        // this.upload_success_count = data.upload_success_count
        // this.upload_fail_count = data.upload_fail_count
        // this.feedback_file_url = data.feedback_file_url
      }
    },
    handleOpenUrl: function handleOpenUrl() {
      window.open(this.feedback_file_url);
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      this.$message.error('upload error');
      throw err;
    },
    // 弹窗关闭时
    closeHandle: function closeHandle() {
      this.reset();
    },
    reset: function reset() {
      this.$refs.upload.clearFiles();
      this.successFileList = [];
    },
    doSubmit: function doSubmit() {
      this.visible = false;
      this.$emit('doSubmit');
    }
  },
  watch: {
    successFileList: {
      handler: function handler(val) {
        if (val.length) this.$emit('uploadSuccess', val);
      },
      deep: true
    }
  }
};